import React, { useContext, useEffect, useState } from "react";
import { ethers } from "ethers";
import { ProjectContext } from "../../ProjectContext";
import { useAccount } from "wagmi";
import Timer from "../Coman/Timer";
import { TfiReload } from "react-icons/tfi";

function NYOTable() {
  const { account, esigner, settings, DailReawardCap, dbuser, Maincontract, DailyRoi, DailyReward, CapDailyReward, getFormattedDate, usertnxDate } = useContext(ProjectContext);
  const [Data, setData] = useState([]);
  const { isConnected } = useAccount();
  const formattedDateTime = getFormattedDate(usertnxDate);

  const getData = async () => {
    if (!isConnected || !settings.token || esigner === null || !settings.contract) return;

    // Call contract to fetch user data
    const getUser = await Maincontract.getuserstakings(account);
    console.log("getUser Dayli", getUser);

    // Ensure getUser is not empty
    if (!getUser || getUser.length === 0) {
      console.error("No user data found for address:", account);
      setData([]);  // Set an empty array if no data
      return;
    }

    // Format and structure the data
    const userData = getUser.map(item => ({
      address: item[1],
      amount: ethers.utils.formatUnits(item[2], 6),
      dailyroi: ethers.utils.formatUnits(item[3], 6),
      dailyreward: Number(ethers.utils.formatUnits(item[4], 6)) + Number(DailReawardCap),
      levelreward: ethers.utils.formatUnits(item[6], 6),
      team: ethers.utils.formatUnits(item[6], 6),
      startdate: new Date(parseInt(item[9]._hex, 16) * 1000), // Convert timestamp to Date
      enddate: new Date(parseInt(item[10]._hex, 16) * 1000), // Convert timestamp to Date
      cappingdate: new Date(parseInt(item[11]._hex, 16) * 1000), // Convert timestamp to Date
      status: parseInt(item[13]), // Assuming status is an integer (0 or 1)
    }));

    const sortedUserData = userData.sort((a, b) => b.startdate - a.startdate);

    setData(sortedUserData);  // Set the data state with sorted user data
  };

  useEffect(() => {
    if (dbuser?.address.toLowerCase() === account?.toLowerCase()) {
      getData();
    }
  }, [dbuser, account]);
  return (
    <div>
      {" "}
      <table className="table">
        <tbody>
          <tr>
            <td className="text-end border-0" colSpan={4}>
              <button className="text-white btn btn-outline-bg-new-primary py-2 px-3" onClick={() => getData()}><TfiReload /></button>
            </td>
          </tr>
          <tr className="table-header">
            <th className="cell">S.NO</th>
            <th className="cell">AMOUNT</th>
            <th className="cell">DAILY REWARD</th>
            <th className="cell">RECEIVED</th>
            <th className="cell"></th>
            <th className="cell">DATE</th>
          </tr>
          {/* Dynamically render rows based on Data */}
          {Data.length > 0 ? (
            Data.map((user, index) => (
              <tr key={index}>
                <td><strong>{index + 1}</strong></td>
                {/* <td>{formatAddress(user.address)}</td> */}
                <td>${user.amount}</td>
                <td>${user.dailyroi} ({DailyRoi}%)</td>
                <td>${user.cappingdate.toLocaleString() === 0 ? user.dailyreward + CapDailyReward : user.dailyreward}</td>
                <td></td>
                <td>
                  Start: {user.startdate.toLocaleString()} <br />
                  {
                    user.cappingdate && user.cappingdate.getTime() === 0 ? (
                      <>
                        <div className="d-flex justify-content-start">
                          End: <h4><Timer targetDate={user.cappingdate && user.cappingdate.getTime() === 0 ? formattedDateTime : user.cappingdate.toLocaleString()} /></h4>
                        </div>
                      </>
                    ) : (
                      <>
                        End: {user.enddate.toLocaleString()}
                      </>
                    )
                  }

                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default NYOTable;
